import PublisherActions from '../../../../actions/PublisherActions';
import CurrencyActions from '../../../../actions/CurrencyActions';
import CustomNotify from '../../../Notify';
import UserStore from '../../../../stores/UserStore';

let lastPaymentSignature = null;
let paymentPending = false;

export const actions = {
    getPaymentDetails(force = false) {
        const signature = 'paymentDetails';
        if (paymentPending || (!force && lastPaymentSignature === signature)) {
            return;
        }
        paymentPending = true;
        PublisherActions.getPaymentDetails(undefined, () => {
            paymentPending = false;
            lastPaymentSignature = signature;
        });
    },

    deletePaymentAccount(id, success) {
        CurrencyActions.deletePaymentAccount({id}, (data) => {
            actions.showNotyMessage('delete');
            actions.getPaymentDetails(true);

            success && success();
        });
    },

    editPaymentAccount(id) {
        let params = {};

        if (id) {
            params.payment_details_id = id;
        } else {
            params.unset_payment_details_id = '1';
        }

        PublisherActions.edit(params).then(data => {
            actions.showNotyMessage('update');
            actions.getPaymentDetails(true);
        });
    },

    showNotyMessage(action) {
        const notyNames = UserStore.getTranslation().notyMessages;
        CustomNotify(notyNames[action]);
    }
};
